export const inlineChildContent = (parentNode, contentKeyMap) => {
  const resultantNode = Object.assign({}, parentNode);
  Object.keys(resultantNode).forEach((key) => {
    const value = resultantNode[key];
    if (key === '@id') {
      if (!contentKeyMap[value]) {
        return;
      }
      Object.keys(contentKeyMap[value]).forEach((childKey) => {
        resultantNode[childKey] = contentKeyMap[value][childKey];
      });
    }
  });
  Object.keys(resultantNode).forEach((key) => {
    const value = resultantNode[key];
    if (value && typeof value === 'object') {
      resultantNode[key] = inlineChildContent(resultantNode[key], contentKeyMap);
    } else if (Array.isArray(value)) {
      value.forEach((item, i) => {
        resultantNode[key][i] = inlineChildContent(resultantNode[key][i], contentKeyMap);
      });
    }
  });
  return resultantNode;
};

export const inlineContent = ({ data }) => {
  const inlinedContent = [];
  const contentKeyMap = {};
  if (data) {
    data['@graph'].forEach((content) => {
      contentKeyMap[content['@id']] = content;
    });
    data.result.forEach((result) => {
      if (!result['@id']) {
        return;
      }
      const content = inlineChildContent({ '@id': result['@id'] }, contentKeyMap);
      if (content) {
        inlinedContent.push(content);
      }
    });
  }
  return inlinedContent;
};



// WEBPACK FOOTER //
// ./src/assets/js/amplience-sdk.js